import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow, SectionLead, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <SectionShell tone="navy" data-id="element-104" data-mp="1cj3egv5fg1ez">
      <Eyebrow data-id="element-105" data-mp="18jukbp6h61iw">
        <span className="text-renal-400" data-id="element-106" data-mp="18kdrqbyi17io">🎁 Bonos exclusivos</span>
      </Eyebrow>
      <SectionTitle className="text-white" data-id="element-107" data-mp="259ldnl315in4">
        Además recibirás estos 5 bonos exclusivos <span className="text-renal-400" data-id="element-108" data-mp="20aqxys0d0a78">(gratis)</span>
      </SectionTitle>
      <p className="mt-4 text-center text-[15px] leading-relaxed text-cream-100/75 sm:text-lg" data-id="element-109" data-mp="20bjznekgo9ii">
        Diseñados para eliminar las dudas que más paralizan a los médicos en la práctica diaria.
      </p>

      <div className="mt-8 space-y-3.5" data-id="element-110" data-mp="1rc6jy45quopc">
        {bonuses.map(bonus => <article key={bonus.tag} className="rounded-2xl border border-white/10 bg-navy-700/60 p-4 sm:p-5" data-id="element-111" data-mp="kvl5563roc0q">
            <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-112" data-mp="1etn9a2mar1k5">
              <span className="rounded-full bg-renal-500 px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-113" data-mp="1eru30oflijco">
                {bonus.tag}
              </span>
              <span className="text-[11.5px] font-bold uppercase tracking-wide text-cream-100/60" data-id="element-114" data-mp="15v2yroqw3y70">
                Valor: <span className="line-through" data-id="element-115" data-mp="1au6294r81wcv">{bonus.value}</span>
              </span>
            </div>
            <div className="mt-3 rounded-xl bg-white p-2.5 sm:p-3" data-id="element-116" data-mp="w1cdsttz25w2">
              <img src={bonus.image} alt={`Mockup digital de ${bonus.title}`} className="mx-auto w-full max-w-sm" width={1256} height={1256} loading="lazy" data-id="element-117" data-mp="10vglxgez4jyq" />
            </div>
            <h3 className="mt-4 font-display text-[19px] font-extrabold leading-tight text-white sm:text-[22px]" data-id="element-118" data-mp="d5cltj0zv2ch">
              {bonus.title}
            </h3>
            <p className="mt-2 text-[13.5px] font-semibold leading-snug text-renal-400 sm:text-[15px]" data-id="element-119" data-mp="2jsjywr541xmm">
              {bonus.lead}
            </p>
            <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-120" data-mp="2f11wrzrcpr02">
              {bonus.bullets.map(b => <li key={b} className="flex items-start gap-2 text-[13px] leading-snug text-cream-100/85" data-id="element-121" data-mp="2b0hxapjb2bar">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-renal-400" aria-hidden="true" data-id="element-122" data-mp="32rpibnu6wf53" />
                  {b}
                </li>)}
            </ul>
          </article>)}
      </div>

      <div className="mt-8" data-id="element-123" data-mp="2tpg5usfd2bp2">
        <CtaButton label="Quiero los 5 bonos gratis" sub="USD 195 en bonos incluidos sin costo adicional" data-id="element-124" data-mp="2tsu902vumoxk" />
      </div>
    </SectionShell>;
}